var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5039 3.00195H19.913C24.8048 3.00195 27.2507 3.00195 28.9493 4.19871C29.436 4.5416 29.868 4.94824 30.2324 5.40629C31.5039 7.00496 31.5039 9.30699 31.5039 13.911V17.7292C31.5039 22.174 31.5039 24.3964 30.8005 26.1713C29.6697 29.0248 27.2782 31.2756 24.2464 32.3399C22.3605 33.002 19.9992 33.002 15.2766 33.002C12.578 33.002 11.2287 33.002 10.1511 32.6237C8.41859 32.0155 7.05203 30.7293 6.40585 29.0987C6.00391 28.0845 6.00391 26.8145 6.00391 24.2747V18.002",
    stroke: "#E86A09",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.9961C31.5 20.7575 29.2614 22.9961 26.5 22.9961C25.5013 22.9961 24.3239 22.8211 23.353 23.0813C22.4902 23.3124 21.8164 23.9863 21.5852 24.849C21.325 25.82 21.5 26.9974 21.5 27.9961C21.5 30.7575 19.2614 32.9961 16.5 32.9961",
    stroke: "#E86A09",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 9.00195L4.50781 9.00195M10.5078 3.00195V15.002",
    stroke: "#E86A09",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file-add.48187ef01f59778f70d20d4d96c77ae4.svg";
export { ForwardRef as ReactComponent };